import React from 'react'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('Header')

const Header = (props) => {
    const { preTitle, title, className } = props
    return (
        <div className={bem(null, null, className)}>
            <h1 className={bem('preTitle')}>{preTitle || ''}</h1>
            <h2 className={bem('title')}>{title}</h2>
        </div>
    )
}

export default Header
